import { useBokaStoresAndServices } from "@repo/api";

import { type StoreConfig, useSettings } from "../settings/SettingsProvider";

export const useBokaServices = () => {
  const { boka_config } = useSettings();
  const { data: bokaStoresAndServices } = useBokaStoresAndServices();
  const enableAll = boka_config?.enable_all_stores_and_services;

  if (enableAll) {
    return bokaStoresAndServices
      ? Array.from(
          new Set(
            Object.values(bokaStoresAndServices).flatMap((location) =>
              Object.values(location).flat()
            )
          )
        )
      : [];
  }

  const extractServiceNameKeys = (stores?: StoreConfig[]): string[] => {
    if (!stores) {
      return [];
    }
    return Array.from(
      new Set(
        stores
          .flatMap((store) => store.service_configs || [])
          .map((config) => config.service_name_key)
      )
    );
  };

  return extractServiceNameKeys(boka_config?.stores);
};
